import { useEffect, useState } from 'react';
import { Download } from 'lucide-react';

interface InstallPrompt extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

export function InstallButton() {
  const [prompt, setPrompt] = useState<InstallPrompt | null>(null);
  useEffect(() => {
    const installable = (event: Event) => { event.preventDefault();setPrompt(event as InstallPrompt); };
    const installed = () => setPrompt(null);
    window.addEventListener('beforeinstallprompt', installable);
    window.addEventListener('appinstalled', installed);
    return () => { window.removeEventListener('beforeinstallprompt', installable);window.removeEventListener('appinstalled', installed); };
  }, []);
  if (!prompt || matchMedia('(display-mode: standalone)').matches) return null;
  return <button type="button" className="brand-search" title="Install Raydius" aria-label="Install Raydius" onClick={() => {
    setPrompt(null);
    void prompt.prompt().then(() => prompt.userChoice).catch(() => { /* Native install UI was unavailable or dismissed. */ });
  }}><Download size={16} strokeWidth={1.6} /></button>;
}
